import React from 'react';
import Image from 'next/image';

const ProudCoSponsor = () => {
    return (
        <div className="relative bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid rounded-lg xl:p-[30px] lg:py-5 lg:px-[15px] md:py-5 md:px-[15px] py-5 px-[15px] lg:mb-10 md:mb-10 mb-6">
            <div className="container xl:container mx-auto !px-0">
                <div className="row grid lg:grid-cols-12 sm:gap-5 md:gap-5 lg:gap-10">
                    <div className="lg:col-span-12 xl:col-span-7 grid">
                        <h1 className="text-white mb-2.5 lg:text-[31px] md::text-[31px] text-[32px] lg:leading-[50px] md:leading-[40px] leading-[40px]">
                            Moweb is a <span className="gradient-text">Proud <br className="block md:hidden lg:hidden" /> Co-Sponsor at Anantam 2025</span>
                        </h1>
                        <p className='dark:text-[#D7DEE5] mb-0 lg:font-bold md:font-bold font-semibold'>
                            Empowering Enterprises & Innovators with Real AI, Digital Transformation & Product Engineering
                        </p>
                    </div>
                    <div className="lg:col-span-12 xl:col-span-5 grid">
                        <div className='flex items-center xl:justify-between xl:gap-1 lg:gap-7 md:gap-7'>
                            <div>
                             <Image
                               src="/img/icons/project-management-institute.svg"
                               alt="project-management-institute"
                               title="project-management-institute"
                               width={211}
                               height={80}
                               className='project-management-img'
                              />
                            </div>
                            <div className='border-r-2 border-[#EBEBEB40] border-solid lg:h-[100px] md:h-[100px] h-[66px]'></div>
                            <div>
                              <Image
                               src="/img/icons/anantam.svg"
                               alt="anantam"
                               title="anantam"
                               width={157}
                               height={100}
                               className='anantam-img'
                              />
                            </div>

                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
};
export default ProudCoSponsor;
